import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from './overview-route'
import type {OverviewRoutePayload} from './route-payload-types'
import {SplitPageLayout} from '@primer/react'
import {Description} from '../components/overview/Description'
import {ChangeSummary} from '../components/overview/ChangeSummary'
import {Findings} from '../components/overview/Findings'
import {OverviewPanel} from '../components/overview/OverviewPanel'
import {Reviewers} from '../components/overview/reviewers/Reviewers'
import {CollapsiblePanel} from '../components/overview/CollapsiblePanel'

export function OverviewEntrypoint() {
  const {data: routeData} = useRouteQuery(pullRequestsOverviewRoute, 'mainQuery')

  return <OverviewComponent routeData={routeData} />
}

type OverviewComponentProps = {
  routeData: OverviewRoutePayload
}

function OverviewComponent({routeData}: OverviewComponentProps) {
  return (
    <>
      <SplitPageLayout.Content as="div" padding="condensed">
        <div className="d-flex gap-4 flex-column">
          <Description descriptionHtml={routeData.description} />
          <CollapsiblePanel heading="Reviews">
            <Reviewers />
          </CollapsiblePanel>
          <ChangeSummary changeHighlights={routeData.changeHighlights} />
          <Findings />
        </div>
      </SplitPageLayout.Content>
      <SplitPageLayout.Pane position="end" sticky divider="none" padding="condensed" width="large">
        <OverviewPanel />
      </SplitPageLayout.Pane>
    </>
  )
}
